import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { newsList } from '@/mocks/newsData';

const categories = ['全部', '工信部政策', 'CCER动态', 'CBAM新规', '工业AI', '双碳科普'];

export default function NewsPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('全部');

  const filtered = activeCategory === '全部'
    ? newsList
    : newsList.filter((n) => n.category === activeCategory);

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-28 pb-14 overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,217,163,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }} />
          </div>
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10 text-center">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-5">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-newspaper-line" /></span>
              工信部 · CCER · CBAM · 工业AI · 双碳科普
            </span>
            <h1 className="font-display font-bold text-3xl md:text-5xl text-white mb-4">
              政策资讯
            </h1>
            <p className="text-firmai-text text-base md:text-lg max-w-2xl mx-auto">
              持续追踪工信部碳排政策、CCER最新动态、CBAM新规、工业AI行业资讯，为工业企业提供权威政策解读
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="pb-20 bg-firmai-darker">
          <div className="w-full px-4 md:px-8 lg:px-12">
            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 mb-8">
              {['全部', '工信部政策', 'CCER动态', 'CBAM新规', '工业AI', '双碳科普'].map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    activeCategory === cat
                      ? 'bg-firmai-green text-firmai-dark'
                      : 'bg-firmai-card border border-firmai-border text-firmai-text hover:border-firmai-green/40 hover:text-white'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* News Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {filtered.map((news) => (
                <article
                  key={news.id}
                  className="bg-firmai-card border border-firmai-border rounded-xl overflow-hidden hover:border-firmai-green/30 transition-all duration-300 cursor-pointer group"
                  onClick={() => navigate(`/news/${news.id}`)}
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={news.image}
                      alt={news.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    {news.hot && (
                      <span className="absolute top-3 right-3 px-2 py-0.5 bg-red-500 text-white text-xs font-semibold rounded-full">
                        热点
                      </span>
                    )}
                  </div>
                  <div className="p-4">
                    <div className="flex items-center justify-between mb-2">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${news.categoryColor}`}>
                        {news.category}
                      </span>
                      <div className="flex items-center gap-2 text-firmai-muted text-xs">
                        <span>{news.date}</span>
                        <span>·</span>
                        <span>{news.readTime}</span>
                      </div>
                    </div>
                    <h2 className="text-white font-semibold text-sm leading-snug mb-2 group-hover:text-firmai-green transition-colors duration-200 line-clamp-2">
                      {news.title}
                    </h2>
                    <p className="text-firmai-muted text-xs leading-relaxed line-clamp-2">{news.summary}</p>
                    <div className="mt-3 flex items-center gap-1 text-firmai-green text-xs font-medium">
                      阅读全文
                      <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200">
                        <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}